<template>
  <div>

    <lk-form slot='content' :model='storeGoods' :rules='validate' :label-width='134'
      label-position="right" ref="storeGoods">
     <div class="cardContainer">
        <lk-card title='供应商及价格信息'>
            <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item label='供应商:' prop='supplierStoreId'>
                  <lk-select clearable  v-if="able"  v-model.trim="storeGoods.supplierStoreId">
                    <lk-option v-for="item in baseData.supplierArr" :value="item.outerPassInfo.id" :key="item.outerPassInfo.id">{{item.outerPassInfo.name}}</lk-option>
                  </lk-select>
                  <span v-else>{{storeGoods.supplierStoreName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='进项税率:' prop='inputTaxRate'>
                   <lk-select v-if="able" placeholder="请选择"  v-model.trim="storeGoods.inputTaxRate">
                    <lk-option v-for="item in baseData.taxRateList" :key="item.value" :value="item.value*1">{{item.name}}</lk-option>
                  </lk-select>
                  <!-- <lk-input clearable :maxlength='100'  v-if="able"  v-model.trim="storeGoods.inputTaxRate" placeholder="请输入"> -->

                  <span v-else>{{storeGoods.inputTaxRate}}%</span>
                </lk-form-item>
              </lk-col>

              <lk-col span='7' :offset='1'>
                <lk-form-item label='销项税率:' prop='outputTaxRate'>
                   <lk-select v-if="able" placeholder="请选择"  v-model.trim="storeGoods.outputTaxRate">
                    <lk-option v-for="item in baseData.taxRateList" :key="item.value" :value="item.value*1">{{item.name}}</lk-option>
                  </lk-select>
                  <!-- <lk-input clearable :maxlength='100'  v-if="able" placeholder="请输入"  v-model.trim="storeGoods.outputTaxRate"></lk-input> -->
                  <span v-else>{{storeGoods.outputTaxRate}}%</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item label='默认进货价（元）:'  prop='defPurchasePrice'>
                  <!-- <lk-input clearable number :maxlength='10'  v-if="able" placeholder="请输入"  v-model.trim="storeGoods.defPurchasePrice"></lk-input> -->
                  <DtpInputNumber 
                    :max="10000000000" 
                    :precision="6" 
                    :ifNeedCheckAllNumber='true'
                    :frontDecimal='5'
                    :maxlength='12'
                    :min="0"
                    v-if="able" 
                    v-model.trim="storeGoods.defPurchasePrice" 
                    clearable placeholder="请输入" 
                    style="width: 100%;">
                  </DtpInputNumber>
                  <span v-else>{{storeGoods.defPurchasePrice}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='默认零售价（元）:' prop='defRetailPrice'>
                  <DtpInputNumber 
                    :max="10000000000" 
                    :precision="6" 
                    :ifNeedCheckAllNumber='true'
                    :frontDecimal='5'
                    :maxlength='12'
                    :min="0"
                    v-if="able" 
                    v-model="storeGoods.defRetailPrice" 
                    clearable placeholder="请输入" 
                    style="width: 100%;">
                  </DtpInputNumber>
                  <span v-else>{{storeGoods.defRetailPrice}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='默认毛利率:'>
                  <span>{{defaultPureRate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item label='成本类型:' prop='paymentType'>
                  <lk-select clearable  v-if="able"  v-model.trim="storeGoods.paymentType">
                    <lk-option v-for="(item,index) in baseData.paymentTypeArr" :key="index" :value='index+1'>{{item.dictionaryName}}</lk-option>
                  </lk-select>
                  <span v-else>{{handleArr(baseData.paymentTypeArr,storeGoods.paymentType)}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='默认斗:' prop='locationIds'>
                  <lk-select clearable  v-if="able"  v-model.trim="storeGoods.locationIds" multiple>
                  <lk-option v-for="(item,index) in baseData.locations" :key="index" :value='String(item.id)'>{{item.name}}</lk-option>
                  </lk-select>
                  <span v-else>{{storeGoods.locations}}</span>
                </lk-form-item>
              </lk-col>

              <lk-col span='7' :offset='1'>
                <lk-form-item label='养护类型:' prop='curingStandard'>
                  <lk-select clearable  v-if="able"  v-model.trim="storeGoods.curingStandard" placeholder="请输入">
                    <lk-option :value="1">一般养护</lk-option>
                    <lk-option :value="2">重点养护</lk-option>
                  </lk-select>
                  <span v-else>{{curingStandardArr[storeGoods.curingStandard]}}</span>
                </lk-form-item>
              </lk-col>
               </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item label='是否医保:' prop='isMedicare'>
                  <lk-radio-group v-if="able"  v-model.trim="storeGoods.isMedicare">
                    <lk-radio :label="1" :value="1">是</lk-radio>
                    <lk-radio :label="2" :value="2">否</lk-radio>
                  </lk-radio-group>
                  <span v-else>{{storeGoods.isMedicare|judgeToString}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='医保名称:' prop='medicareName'>
                  <lk-input clearable :maxlength='100'  v-if="able"  v-model.trim="storeGoods.medicareName" placeholder="请输入">
                  </lk-input>
                  <span v-else>{{storeGoods.medicareName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='有效期预警天数:' prop='periodAlertDays'>
                <lk-select  clearable   v-if="able"  v-model.trim="storeGoods.periodAlertDays">
                <lk-option v-for="(item,index) in baseData.periodAlertDaysArr" :value='item.dictionaryIndex' :key="index">{{item.dictionaryName}}</lk-option>
                </lk-select>
                <span v-else>{{handleArr(baseData.periodAlertDaysArr,storeGoods.periodAlertDays)}}</span>
                </lk-form-item>
              </lk-col>

              </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item label='有效期禁止销售天数:' prop='periodForbidSaleDays'>
                  <lk-input number clearable :maxlength='10'  v-if="able"  v-model.trim="storeGoods.periodForbidSaleDays"></lk-input>
                  <span v-else>{{storeGoods.periodForbidSaleDays}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' :offset='1'>
                <lk-form-item label='助记码:'  prop='mnemonicCode'>
                  <lk-input clearable :maxlength='15'  v-if="able" placeholder="请输入"  v-model.trim="storeGoods.mnemonicCode"></lk-input>
                  <span v-else>{{storeGoods.mnemonicCode}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
        </lk-card>
        </div>
        </lk-form>
  </div>
</template>
<script>
import utils from '../../../libs/utils';
import DtpInputNumber from '../../DtpInputNumber';

export default {
  name: 'StoreDecoction',
  components: {
    DtpInputNumber
  },
  props: {
    info: {
      type: Object,
      // required: true,
    },
    able: {
      type: Boolean,
    },
    baseData: {
      type: Object,
    },
    disableDTP: {
      type: Boolean,

    },
  },
  model: {
    prop: 'info',
    event: 'change',

  },
  computed: {
    defaultPureRate() { // 计算默认毛利率
      return utils.defaultPureRate(this.storeGoods.defRetailPrice, this.storeGoods.defPurchasePrice);
    }
  },
  watch: {

    storeGoods: {
      handler() {
        this.$emit('change', this.storeGoods);
        this.$emit('on-change', this.storeGoods);
      },
      deep: true,
    },
  },
  data() {
    return {
      storeGoods: { },
      curingStandardArr: ['', '一般养护', '重点养护'],
      validate: {
        supplierStoreId: [
          {
            required: true, message: '请选择供应商', trigger: 'change', type: 'number',
          },
        ],
        inputTaxRate: [
          {
            required: true, message: '请选择进项税率', trigger: 'change', type: 'integer',
          },
        ],

        outputTaxRate: [
          {
            required: true, message: '请选择销项税率', trigger: 'change', type: 'integer',
          },
        ],
        paymentType: [
          {
            required: true, message: '请选择成本类型', trigger: 'change', type: 'number',
          },
        ],
        curingStandard: [
          {
            required: true, message: '请选择养护类型', trigger: 'change', type: 'number',
          },
        ],
        locationIds: [
          {
            required: true, message: '请选择默认斗', trigger: 'change', type: 'array',
          },
        ],
        defPurchasePrice: [
          {
            required: true, message: '请输入默认进货价', trigger: 'change', type: 'number',
          },
          {
            validator: utils.validate.priceValidator, trigger: 'change', type: 'number', precision: 6,
          },
        ],
        defRetailPrice: [
          {
            required: true, message: '请输入默认零售价', trigger: 'change', type: 'number',
          },
        ],
        periodForbidSaleDays: [

          {

            validator: utils.validate.numberRange, params: { min: 0 }, trigger: 'change', type: 'integer',
          },
        ],
        periodAlertDays: [
          {
            required: true, message: '请选择有效期预警天数', trigger: 'change', type: 'integer',
          },
          {

            validator: utils.validate.numberRange, params: { min: 0 }, trigger: 'change', type: 'integer',
          },
        ],
        inventoryWarning: [

          {

            validator: utils.validate.numberRange, params: { min: 0, max: 100000000 }, trigger: 'change', type: 'integer',
          },
        ],
        inventoryWarningMax: [

          {

            validator: utils.validate.numberRange, params: { min: 0, max: 100000000 }, trigger: 'change', type: 'integer',
          },
        ],
      },
    };
  },
  methods: {
    handleArr(arr, index) {
      return utils.exchangeDictionary(arr, index);
    },
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.storeGoods.validate((valid) => {
          this.$emit('change', this.storeGoods);
          resolve(valid);
        });
      });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.storeGoods = this.info;
    }
    if (!this.storeGoods.paymentType) {
      this.$set(this.storeGoods, 'paymentType', 1);
      this.$set(this.storeGoods, 'curingStandard', 2);
      this.$set(this.storeGoods, 'periodAlertDays', 240);
      // this.storeGoods.paymentType = 1;
    }
  },
};
</script>
